import { render, staticRenderFns } from "./video-voice.vue?vue&type=template&id=148e3408&scoped=true"
import script from "./video-voice.vue?vue&type=script&lang=js"
export * from "./video-voice.vue?vue&type=script&lang=js"
import style0 from "./video-voice.vue?vue&type=style&index=0&id=148e3408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e3408",
  null
  
)

export default component.exports